module.exports = __webpack_public_path__ + "img/brand-2.fb5c7a83.png";